<template >
  <div class="detail" v-if="tieZiObj && tieZiObj.data">
    <div  class="content"   >
      <div class="content-item">
        <div class="top">
          <div class="headPortrait"><img src="../assets/user.png" alt=""></div>
          <div class="baseInfo">
            <div class="nameAndTime">

              <span class="name">{{tieZiObj.data.userName }}</span>

              <span class="time">{{tieZiObj.data.createTime| formatDate}}</span>
              <span class="status color1">楼主</span>
            </div>
            <div class="typeAndTitle">
              <span  v-if="tieZiObj.data.tieziType===1" class="type" style="background: #EC971F">投诉</span>
              <span  v-if="tieZiObj.data.tieziType===2 " class="type" style="background: #E9DC51">建议</span>
              <span  v-if="tieZiObj.data.tieziType===3 " class="type"style="background: #25A597">咨询</span>
              <span  v-if="tieZiObj.data.tieziType===4 " class="type">表扬</span>
              <span class="title" >
                  {{tieZiObj.data.title}}
                </span>
            </div>
          </div>
        </div>

        <div style="font-size:0.7rem;">
          <span class="sizeStyle" >发帖人信息:</span><span>班级(部门):{{tieZiObj.data.classNameOrDepartment}}</span>&nbsp;&nbsp;|&nbsp;&nbsp;<span>联系电话:{{tieZiObj.data.telPhone}}</span>
        </div>

        <div style="font-size:0.7rem;">
          <span> {{tieZiObj.data.serviceItemName}}/{{tieZiObj.data.serviceItemIdName}}</span>&nbsp;&nbsp;|&nbsp;&nbsp;<span>广西交职院后勤与资产管理处、保卫处</span>
        </div>
        <div class="center">
          <span  class="sizeStyle" >发帖内容:</span>{{tieZiObj.data.content}}

        </div>



        <div class="imgShow"  v-if=" tieZiObj.data.image != null">
          <div class="imgShow-item"  v-for="(url,idx) in tieZiObj.data.image.split(';')" :key="idx">
            <img :src="getImgUrl(url) "  preview preview-text="">
          </div>
        </div>

        <div class="bottom1">
          <div class="option">
            <div class="browse">
              浏览:<span  v-if="tieZiObj.data.browseCount===null" class="browseCount">0</span>
              <span  v-else class="browseCount">{{tieZiObj.data.browseCount}}</span>
              &nbsp;&nbsp;
              <span  @click="myGreat(tieZiObj.data.id)" class="iconfont aliaixin" style="position:relative;top:1px;":style="likeStyle"></span>
              <span v-if="tieZiObj.data.greatCount===null" class="greatCount">0</span>
              <span  v-else class="greatCount">{{tieZiObj.data.greatCount}}</span>


              &nbsp;&nbsp;
              <span  @click="toApply" class="iconfont alipinglun1" style="position:relative;top:1px;"></span>
              <span v-if="tieZiObj.data.replyCount===null" class="replyCount">0</span>
              <span  v-else class="replyCount">{{tieZiObj.data.replyCount}}</span>
              &nbsp;&nbsp;
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="height:0.5rem;width:100%;background:#efefef;"></div>

    <!--实现内容修改 审核 选择回复内容进行回复-->
    <div   v-if="tieZiObj && tieZiObj.data">

      <div class="modifyContent"  v-if="!verifyIsOkFlag">
        <textarea  v-model="tieZiTitle" style=" border:none;margin-left: 10px;width: 95%;font-size: 12px" rows="1"  wrap="hard"></textarea>
        <van-button type="info" size="mini" style="margin-left: 30px;padding: 0px 5px 5px;" @click="modifyTitle(tieZiObj.data.id)">修改帖子标题</van-button>
      </div>
       <div class="modifyContent"  v-if="!verifyIsOkFlag">
       <textarea  v-model="contentData" style=" border:none;margin-left: 10px;width: 95%;font-size: 12px" rows="3"  wrap="hard"></textarea>
       <van-button type="info" size="mini" style="margin-left: 30px;padding: 0px 5px 5px;" @click="modifyContent(tieZiObj.data.id)">修改帖子内容</van-button>
      </div>
      <div class="modifyContent">
        <span class="sizeStyle" v-if="verifyIsOkFlag">
            已审核
        </span>

      <span v-else>
             <van-button type="info" size="mini" style="margin-left: 30px;padding: 0px 5px 5px;" @click="censorPostById(tieZiObj.data.id)">审核帖子</van-button>
        </span>
      <van-button type="info" size="mini" style="margin-left: 30px;padding: 0px 5px 5px;" @click="selectReplyContent(tieZiObj.data.id)">选择回复的内容</van-button>

    </div>
    </div>

    <div class="comment"  v-if="replyObj && replyObj.data">
      <div class="menu" style="overflow:hidden;font-size:0.7rem;padding:0.1rem 0.5rem;border-bottom:1px solid lightgray;">
            <div style="float:left;">
             {{replyObj.data.length}}&nbsp;回复
            </div>
            <div style="float:right;">
              <span @click="oldReply" style="position:relative;top:1px;":style="oldReplyStyle">最早回复</span> | <span  @click="newReply" style="position:relative;top:1px;":style="newReplyStyle">最新回复</span>
            </div>
      </div>
      <div class="comment-content"  v-for="(item, index) in replyObj.data" :key="index" >
        <div class="comment-content-item">
          <div class="comment-top">
            <div class="comment-headPortrait"><img src="../assets/user.png" alt=""></div>
            <div class="comment-baseInfo">
              <div class="comment-nameAndTime">

                <span  class="comment-name">{{item.realName }}</span>
                <span class="comment-time">{{item.commentTime |formatTime}}</span>
                <span v-if="item.roleType===2 && IsHost(item.userId) " class="status color1">楼主</span>
                <span v-if="item.roleType===1" class="status color2">官方</span>
              </div>
            </div>
          </div>
          <div class="comment-center">
            {{item.commentContent}}
          </div>
          <div class="comment-bottom1">
            <div class="comment-option">
              <div class="comment-browse">
               <!-- <span class="iconfont aliaixin" style="position:relative;top:1px;"></span><span class="likeCount">50</span>-->
                <van-button type="warning" size="mini" style="margin-left: 5px " @click="delComment(item.id,item.tieZiId)">删除</van-button>
                <span  @click="commentGreat(item.id,item.tieZiId)" class="iconfont aliaixin" style="position:relative;top:1px;"></span>
                <span v-if="item.greatNum===null" class="greatCount">0</span>
                <span  v-else class="greatCount">{{item.greatNum}}</span>
                &nbsp;&nbsp;
                <span class="comment-replyCount">{{index+1}}楼</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="reply" style="position:fixed;bottom:0;width:100%;text-align:center;overflow:hidden;">
        <mt-field  v-focus="focusStatus"  placeholder="回复" v-model="content" style="float:left;width:80%;"></mt-field>
        <button type="default" :mini="true" style="float:left;width:20%;height:48px;border-radius:0px;border:none;background:#efefef;" @click="replyContent()">提交</button>
    </div>
  </div>
</template>

<script>
  import { getMyTieZiById,getGreatCount,addReplyContent,getNewReply,getOldReply,getCommentGreatCount,getReplyCount,delMobileCommentById,modifyTitleById,modifyContentById,censorPostById,replyContentList,selectReplyContent,OK,HOST} from '../api/data.js'
  import contentText from './contentText'
  import { Toast,MessageBox} from 'mint-ui';
  import moment from 'moment'
  import $ from 'jquery'
  import preview from 'vue-photo-preview'
  import 'vue-photo-preview/dist/skin.css'
  import Vue from 'vue'
  import { Button,Dialog } from 'vant';
  Vue.use(Button);
  Vue.use(preview)
  export default {
    data() {
      return {
        content:'',//输入评论的内容
        tieZiDetail:[],//帖子详情
        greatType:"zj",//点赞标志
        commentGreatFlag:0,
        isChoose:false,
        tieZiTitle:"",//帖子标题
        contentData:"",//帖子内容
        tieZiId:this.$route.query.tieZiId,//帖子id
        focusStatus:false,
        replyMessage:"",//保存选择回复内容
        verifyIsOkFlag:false,//是否已审核标志
        likeStyle:{ //点赞样式
          position:"relative",
          top:"1px",
          color:"gray"
        },
        oldReplyStyle:{ //最早回复样式
          position:"relative",
          top:"1px",
          color:"gray"
        },
        newReplyStyle:{//最新回复样式
          position:"relative",
          top:"1px",
          color:"gray"
        },
        commentStyle:{
          position:"relative",
          top:"1px",
          color:"gray"
        },
        replyObj:[], //回复或评论内容
        hostUserId:'',//发帖用户id
        dialogFormVisible:false,
        form: {
          name: '',
          region: '',
        },
        formLabelWidth: '120px'
      }


    },
    filters: {
      formatDate: function (value) {
        return moment(value).format('YYYY-MM-DD HH:mm')
      },
      formatTime: function (value) {
        return moment(value).format('MM-DD HH:mm')
      },
      hideMiddle(val) {
         if(val!==null){
           return `${val.substring(0,1)}**`
         }

      }
    },
    computed: {
      tieZiObj: {
        get: function(){
          return this.tieZiDetail; // 在这里把临时对象的值通过计算属性赋值给页面中用到的对象
        },
      },
    },
    directives:{
      focus: {
        update: function (el,{value}) {
          let input=el.querySelector('input');
          if(value){
            input.focus();
          }
        }
      }
    },
    mounted() {

      setTimeout(()=>{
        this.getTieZiDetail(this.tieZiId);
        this.newReply();

      },25)



    },
    methods: {

      showImage(){
        this.isChoose = !this.isChoose

      },
      getImgUrl(imageUrl){
      /*  console.log("imageUrl:"+imageUrl);*/
        return HOST+imageUrl;
      },
      //根据帖子id修改帖子标题
      modifyTitle(id){
        if(localStorage.getItem("adminId")!==null && localStorage.getItem("adminId").length!==0){
          modifyTitleById(id,this.tieZiTitle).then(res=>{
            if(res.status === OK) {
              if(res.data.success==true){

                this.$toast({
                  message:res.data.data,
                  duration:900,

                })
                this.getTieZiDetail(id);
              }else{
                Toast('修改失败')
              }
            }
          }).catch(error=>{
            console.log("错误"+error);
          })
        }else {//没有登录，需要登录
          this.$router.push({path:'/login',
            query: {
              redirect: '/adminDetail?tieZiId='+id  // 将跳转的路由path作为参数，登录成功后跳转到该路由
            }})
        }

      },
      //根据帖子id修改帖子内容
      modifyContent(id){
        if(localStorage.getItem("adminId")!==null && localStorage.getItem("adminId").length!==0){
          modifyContentById(id,this.contentData).then(res=>{
            if(res.status === OK) {
              if(res.data.success==true){

                this.$toast({
                  message:res.data.data,
                  duration:900,

                })
                this.getTieZiDetail(id);
              }else{
                Toast('修改失败')
              }
            }
          }).catch(error=>{
            console.log("错误"+error);
          })
        }else {//没有登录，需要登录
          this.$router.push({path:'/login',
            query: {
              redirect: '/adminDetail?tieZiId='+id  // 将跳转的路由path作为参数，登录成功后跳转到该路由
            }})
        }

      },
      //根据帖子id进行审核
      censorPostById(id){
        if(localStorage.getItem("adminId")!==null && localStorage.getItem("adminId").length!==0){
          censorPostById(id,localStorage.getItem("adminName")).then(res=>{
            if(res.status === OK) {
              if(res.data.success==true){
                this.$toast({
                  message:res.data.data,
                  duration:900,

                })
                this.getTieZiDetail(id);
              }else{
                Toast('审核失败')
              }
            }
          }).catch(error=>{
            console.log("错误"+error);
          })
        }else {//没有登录，需要登录
          this.$router.push({path:'/login',
            query: {
              redirect: '/adminDetail?tieZiId='+id  // 将跳转的路由path作为参数，登录成功后跳转到该路由
            }})
        }

      },


      //判断评论是否是发帖用户的评论
      IsHost(commentUserId){
        return  this.hostUserId == commentUserId;
      },

      getTieZiDetail(value){
        getMyTieZiById(value).then(res=>{
          if(res.status === OK) {
            if(res.data.success==true){
              this.tieZiDetail=[];
              this.tieZiDetail=res.data ; // 在这里用临时变量接受服务端返回值
              //console.log(res.data.data);
              this.tieZiTitle = res.data.data.title; //帖子标题
              this.contentData = res.data.data.content;//帖子内容

              this.verifyIsOkFlag =res.data.data.verifyIsOk;//获取审核状态
              this.hostUserId = this.tieZiDetail.data.userId //获取发帖用户id
            }else{
              Toast('获取帖子失败')
            }
          }
        }).catch(error=>{
          console.log("错误"+error);
        })


      },
      myGreat(value){
        //用户需要登录才能点赞
        if(localStorage.getItem("adminId")!==null && localStorage.getItem("adminId").length!==0){
          if(this.likeStyle.color=="red"){
            this.likeStyle.color="gray"
            //点赞数减1
            this.greatType ="js"//减1标志
            getGreatCount(value,this.greatType).then(res=>{
              if(res.status === OK) {
                if(res.data.success==true){
                  this.getTieZiDetail(value);
                  //Toast('取消点赞')
                }else{
                  //Toast('点赞失败')
                }
              }
            }).catch(error=>{
              console.log("错误"+error);
            })

          }else{

            this.likeStyle.color="red"
            //点赞数加1
            this.greatType ="zj" //加1标志
            getGreatCount(value,this.greatType).then(res=>{
              if(res.status === OK) {
                if(res.data.success==true){
                  this.getTieZiDetail(value);
                  // Toast('已点赞')
                }else{
                  // Toast('点赞失败')
                }
              }
            }).catch(error=>{
              console.log("错误"+error);
            })
          }

        }else {//没有登录，需要登录
          this.$router.push({path:'/login',
            query: {
              redirect: '/detail?tieZiId='+value  // 将跳转的路由path作为参数，登录成功后跳转到该路由
            }})
        }

      },
      toApply(){
        this.focusStatus=!this.focusStatus;
      },
      //管理员删除评论或回复信息
      delComment(id,tieZiId){
        if(localStorage.getItem("adminId")!==null && localStorage.getItem("adminId").length!==0){
          console.log("adminId:"+localStorage.getItem("adminId"))
          delMobileCommentById(id,tieZiId,localStorage.getItem("adminId")).then(res=>{
            /*console.log(res.data)*/
            if(res.status === OK) {
              if(res.data.success==true){

                this.$toast({
                  message:res.data.data,
                  duration:900,

                })
                this.newReply();
              }else{
                Toast('删除失败')
              }
            }
          }).catch(error=>{
            console.log("错误"+error);
          })
        }else {//没有登录，需要登录
          this.$router.push({path:'/login',
            query: {
              redirect: '/adminDetail?tieZiId='+tieZiId  // 将跳转的路由path作为参数，登录成功后跳转到该路由
            }})
        }


      },

      //选择回复内容进行回复
      selectReplyContent(id){
        if(localStorage.getItem("adminId")!==null && localStorage.getItem("adminId").length!==0){

          replyContentList().then(res=>{
            if(res.status === OK) {
              if(res.data.success==true){
                if(res.data.data.length>0){
                  this.replyMessageId = res.data.data[0].id;
                }else{
                  this.replyMessageId="";
                }

                for (var i = 0; i < res.data.data.length; i++) {
                  this.replyMessage += "<input  type='radio' font-size: 20px name='stopRemarks' class='same' value='" + res.data.data[i].id + "'>" + res.data.data[i].replyContent + "</br>";

                }
                Dialog.confirm({
                  title: '选择回复的内容',
                  message: this.replyMessage
                }).then(() => {  //确认
                  let replyMessageId= $("input[type='radio']:checked").val();
                  if(typeof replyMessageId === 'undefined'){
                    Toast('请选择回复内容')
                    this.replyMessage="";
                    return;
                  }
                  selectReplyContent(this.tieZiId,localStorage.getItem("adminId"),localStorage.getItem("operator"),replyMessageId).then(res=>{
                    if(res.status === OK) {
                      if(res.data.success==true){
                        this.$toast({
                          message: '回复成功!',
                          duration:900
                        })

                        this.newReply();
                        this.getTieZiDetail(this.tieZiId)

                      }else{
                        Toast('回复失败!')
                      }
                    }
                  }).catch(error=>{
                    console.log("错误"+error);
                  })

                  this.replyMessage=""; //重置

                }).catch(() => { //取消
                  // on cancel
                  this.replyMessage="";
                });

              }else{
                Toast('获取回复内容失败')
              }
            }
          }).catch(error=>{
            console.log("错误"+error);
          })

        }else {//没有登录，需要登录
          this.$router.push({path:'/login',
            query: {
              redirect: '/adminDetail?tieZiId='+this.tieZiId  // 将跳转的路由path作为参数，登录成功后跳转到该路由
            }})
        }

      },
      //回复
      replyContent(){
        if(localStorage.getItem("adminId")!==null && localStorage.getItem("adminId").length!==0){
          // 得到输入的数据
          const inputTodo = this.content.trim()
          // 检查合法性
          if(!inputTodo) {
            this.$toast.fail({
              message: '回复内容不能为空!',
              duration:800
            })
            return
          }
          addReplyContent(this.tieZiId,localStorage.getItem("adminId"),localStorage.getItem("operator"),this.content).then(res=>{
            if(res.status === OK) {
              if(res.data.success==true){
                this.$toast({
                  message: '回复成功!',
                  duration:900
                })
                this.content='';//清空评论内容
                this.newReply();
                this.getTieZiDetail(this.tieZiId)

              }else{
                Toast('回复失败!')
              }
            }
          }).catch(error=>{
            console.log("错误"+error);
          })

        }else {//没有登录，需要登录
          this.$router.push({path:'/login',
            query: {
              redirect: '/adminDetail?tieZiId='+this.tieZiId  // 将跳转的路由path作为参数，登录成功后跳转到该路由
            }})
        }
      },
      //按照最早回复论排序
      oldReply(){
        this.newReplyStyle.color="gray"
        this.oldReplyStyle.color="blue"
        getOldReply(this.tieZiId).then(res=>{
          if(res.status === OK) {
            if(res.data.success==true){
              this.replyObj=[];
              this.replyObj=res.data.data ; // 在这里用临时变量接受服务端返回值
              this.ReplyCount(this.tieZiId,this.replyObj.data.length);
              this.getTieZiDetail(this.tieZiId)
              /*if(this.replyObj.data.length==0){
                this.$toast.fail({
                  message: '暂无评论',
                  duration:400
                })
              }*/
            }else{
              Toast('获取帖子失败')
            }
          }
        }).catch(error=>{
          console.log("错误"+error);
        })

      },
      //按照最新回复排序
      newReply(){
        this.newReplyStyle.color="blue"
        this.oldReplyStyle.color="gray"
        getNewReply(this.tieZiId).then(res=>{
          if(res.status === OK) {
            if(res.data.success==true){
              this.replyObj=[];
              this.replyObj=res.data.data ; // 在这里用临时变量接受服务端返回值
              this.ReplyCount(this.tieZiId,this.replyObj.data.length);
              this.getTieZiDetail(this.tieZiId)
              /*if(this.replyObj.data.length==0){
                this.$toast.fail({
                  message: '暂无评论',
                  duration:400
                })
              }*/
            }else{
              Toast('获取帖子失败')
            }
          }
        }).catch(error=>{
          console.log("错误"+error);
        })
      },

      ReplyCount(id,replyCount){
        //console.log("帖子id："+id);
        //console.log("帖子回复数量："+replyCount);
        getReplyCount(this.tieZiId,this.replyObj.data.length).then(res=>{
          if(res.status === OK) {
            if(res.data.success==true){
            }else{
              //Toast('浏览失败')
            }
          }
        }).catch(error=>{
          console.log("错误"+error);
        })
      },

      commentGreat(id,tieZiId){
        //用户需要登录才能点赞
        //console.log("commentGreat id:"+id);
        //console.log("tieZiId:"+tieZiId);

        let FLAG ="zj";
        if(this.commentGreatFlag===0){
           FLAG = "zj"

        }else{
          FLAG = "js"

        }
        //console.log("FLAG:"+FLAG);
        if(localStorage.getItem("adminId")!==null && localStorage.getItem("adminId").length!==0){
          if(FLAG === "js"){
            //点赞数减1
            getCommentGreatCount(id,FLAG).then(res=>{
              this.commentGreatFlag=0;
              FLAG ="zj"
              if(res.status === OK) {
                if(res.data.success==true){
                  this.newReply();
                  Toast('取消点赞')

                }else{
                  //Toast('点赞失败')
                }
              }
            }).catch(error=>{
              console.log("错误"+error);
            })

          }else{

            //点赞数加1
            //console.log("点赞数加1:"+this.commentGreatFlag);

            getCommentGreatCount(id,FLAG).then(res=>{
              this.commentGreatFlag=1;
              FLAG ="js"
              if(res.status === OK) {
                if(res.data.success==true){
                  this.newReply();
                   Toast('已点赞')

                }else{
                  // Toast('点赞失败')
                }
              }
            }).catch(error=>{
              console.log("错误"+error);
            })
          }

        }else {//没有登录，需要登录
          this.$router.push({path:'/login',
            query: {
              redirect: '/adminDetail?tieZiId='+tieZiId  // 将跳转的路由path作为参数，登录成功后跳转到该路由
            }})
        }

      },
    },
    components:{
      contentText,

    },

  }
</script>

<style lang="scss" scoped>
  .detail{
    margin-bottom:48px;
    .content{
      font-size:0.8rem;
      color:gray;
      .content-item{
        border-bottom:1px solid lightgray;
        padding:0.8rem 0.5rem;
        .top{
          display:flex;
          .headPortrait{
            margin-right: 0.3rem;
            img{
              width: 2rem;
              height:2rem;
            }
          }
          .baseInfo{
            padding:1px 0;
            .nameAndTime{
              text-align:left;
              overflow: hidden;
              .name{
                margin-right:2rem;
              }
              .time{

              }
            }
            .typeAndTitle{
              overflow:hidden;
              .type{
                padding:0.1rem 0.5rem;
                color:white;
                background:#4caf50;
                border-radius: 10%;
                margin-right:1rem;
                font-weight:lighter;
              }
              .title{
                color:black;
              }
            }
          }
        }
        .center{
          padding:0.5rem;
          text-align:left;
         /* .imgShow{
             display:flex;
            align-items: center;
            justify-content: space-around;


          }*/
        }


        .bottom1{
          overflow:hidden;
          .classify{
            float:left;
          }
          .option{
            float:right;
            overflow:hidden;
            .browse{
              float:left;
            }
          }
        }
      }
    }

    .comment{
      font-size:0.8rem;
      color:gray;
      .comment-content-item{
        border-bottom:1px solid lightgray;
        padding:0.3rem 0.5rem;
        .comment-top{
          display:flex;
          height:2rem;
          .comment-headPortrait{
            margin-right: 0.3rem;
            img{
              width: 2rem;
              height:2rem;
            }
          }
          .comment-baseInfo{
            padding:1px 0;
            .comment-nameAndTime{
              text-align:left;
              overflow: hidden;
              .comment-name{
                margin-right:0.5rem;
              }
              .comment-time{

              }
            }
          }
        }
        .comment-center{
          padding:0 0.5rem;
          text-align:left;
        }

        .comment-bottom1{
          overflow:hidden;
          .comment-classify{
            float:left;
          }
          .comment-option{
            float:right;
            overflow:hidden;
            .comment-browse{
              float:left;
            }
          }
        }
      }
    }
  }
  .status {
    display: inline-block;
    text-align: center;
    height: 12px;
    line-height: 11px;
    width: 30px;
    border-radius: 2px;
    font-size: 10px;
    margin-left: 10px;
  }
  .color1 {
    border: 1px solid #74C106;
    color: #74C106;
  }
  .color2 {
    border: 1px solid #FB3B07;
    color: #FB3B07;
  }
  img {
    //transform: scale(1);          /*图片原始大小1倍*/
    transition: all ease 0.5s; }  /*图片放大所用时间*/


  img.active {
    transform: scale(1);          /*点击图片实现显示原图*/
    position: absolute;           /*是相对于前面的容器定位的，此处要放大的图片，不能使用position：relative；以及float，否则会导致z-index无效*/
    z-index: 100; }


  .imgShow{
    display:flex;
    align-items: center;
    justify-content: space-around;

  }
  .imgShow-item{
    width:3.5rem;
    height:3.5rem;
    padding:0.3rem;
    display: inline-block;

    img{
      width:100%;
      height:100%;
    }

  }

  .sizeStyle{
    font-weight:bold;
    color:black;
    margin-left: 30px
  }

  .modifyContent{
    border-bottom:1px solid lightgray;
    padding:0.3rem 0.5rem;

  }
</style>



// WEBPACK FOOTER //
// src/components/adminDetail.vue